import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import api from "../../../services/api";

function statusUsuario(usuario) {
    if (usuario.ativo === false) return { texto: "Desativado", classe: "badge-secondary" };
    if (!usuario.isAutorizado) return { texto: "Pendente", classe: "badge-warning" };
    return { texto: "Ativo", classe: "badge-success" };
}

export default class Usuarios extends Component {

    constructor(props) {
        super(props);

        this.state = {
            usuarios: [],
            carregando: true,
            erro: ""
        };
    }

    componentDidMount() {
        this.carregarUsuarios();
    }

    carregarUsuarios = async () => {
        this.setState({ carregando: true, erro: "" });
        try {
            let resposta = await api.get("/admin/users");
            this.setState({ usuarios: resposta.data.users || [], carregando: false });
        } catch (erro) {
            this.setState({ erro: "Não foi possível carregar os usuários.", carregando: false });
        }
    };

    aprovar = async (usuario) => {
        try {
            await api.put(`/admin/users/${usuario._id}`, { isAutorizado: true });
            await this.carregarUsuarios();
        } catch (erro) {
            window.showNotification && window.showNotification("Não foi possível aprovar o usuário.", "danger");
        }
    };

    confirmarDesativacao = (usuario) => {
        swal({
            title: "Desativar usuário?",
            text: `${usuario.nome} não conseguirá mais acessar o sistema.`,
            icon: "warning",
            buttons: ["Cancelar", "OK"],
            dangerMode: true
        }).then((confirmado) => {
            if (confirmado) this.desativar(usuario);
        });
    };

    desativar = async (usuario) => {
        try {
            await api.delete(`/admin/users/${usuario._id}`);
            await this.carregarUsuarios();
        } catch (erro) {
            window.showNotification && window.showNotification(
                (erro.response && erro.response.data && erro.response.data.message) || "Não foi possível desativar o usuário.",
                "danger"
            );
        }
    };

    reativar = async (usuario) => {
        try {
            await api.put(`/admin/users/${usuario._id}`, { ativo: true });
            await this.carregarUsuarios();
        } catch (erro) {
            window.showNotification && window.showNotification(
                (erro.response && erro.response.data && erro.response.data.message) || "Não foi possível reativar o usuário.",
                "danger"
            );
        }
    };

    render() {
        let { usuarios, carregando, erro } = this.state;

        return (
            <Fragment>
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-user">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-md-8">
                                            <h4 className="card-title">Usuários</h4>
                                        </div>
                                        <div className="col-md-4 text-right">
                                            <Link to="/admin/usuarios/novo" className="btn btn-primary btn-round">Novo usuário</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    {erro && <div className="alert alert-danger" role="alert">{erro}</div>}
                                    {carregando ? (
                                        <p>Carregando...</p>
                                    ) : (
                                        <table className="table table-striped table-hover table-bordered table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Nome</th>
                                                    <th>Usuário</th>
                                                    <th>E-mail</th>
                                                    <th>Unidade</th>
                                                    <th>Funções</th>
                                                    <th>Status</th>
                                                    <th>Ações</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {usuarios.map((usuario) => {
                                                    let status = statusUsuario(usuario);
                                                    return (
                                                        <tr key={usuario._id}>
                                                            <td>{usuario.nome}</td>
                                                            <td>{usuario.username}</td>
                                                            <td>{usuario.email}</td>
                                                            <td>{usuario.unidade}</td>
                                                            <td>{(usuario.roles || []).map((role) => role.name).join(", ")}</td>
                                                            <td><span className={`badge ${status.classe}`}>{status.texto}</span></td>
                                                            <td>
                                                                <div className="block-acao">
                                                                    {usuario.ativo === false ? (
                                                                        <button className="btn btn-link btn-success" onClick={() => this.reativar(usuario)}>Reativar</button>
                                                                    ) : (
                                                                        <Fragment>
                                                                            {!usuario.isAutorizado && (
                                                                                <button className="btn btn-link btn-success" onClick={() => this.aprovar(usuario)}>Aprovar</button>
                                                                            )}
                                                                            <Link to={`/admin/usuarios/${usuario._id}`} className="btn btn-link btn-warning edit"><i className="fa fa-edit"></i></Link>
                                                                            <button className="btn btn-link btn-danger remove" onClick={() => this.confirmarDesativacao(usuario)}><i className="fa fa-times"></i></button>
                                                                        </Fragment>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
